module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "spinner spinner--circle-6",
    style: (_vm.styles),
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 100 100"
    }
  }, [_c('g', {
    staticClass: "anim-0"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "50",
      "fill": _vm.background
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-1"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "5",
      "fill": "white"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-2"
  }, [_c('circle', {
    attrs: {
      "cx": "75",
      "cy": "50",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "25",
      "y1": "50",
      "x2": "75",
      "y2": "50",
      "stroke": "white",
      "stroke-width": "3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-3"
  }, [_c('circle', {
    attrs: {
      "cx": "50",
      "cy": "25",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "25",
      "x2": "25",
      "y2": "75",
      "stroke": "white",
      "stroke-width": "3"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "50",
      "y1": "25",
      "x2": "75",
      "y2": "75",
      "stroke": "white",
      "stroke-width": "3"
    }
  })]), _vm._v(" "), _c('g', {
    staticClass: "anim-4"
  }, [_c('circle', {
    attrs: {
      "cx": "75",
      "cy": "25",
      "r": "5",
      "fill": "white"
    }
  }), _vm._v(" "), _c('line', {
    attrs: {
      "x1": "75",
      "y1": "25",
      "x2": "25",
      "y2": "25",
      "stroke": "white",
      "stroke-width": "3"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e68a197"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/Circle6.vue
// module id = 910
// module chunks = 170